<div>
  <app-dashboard-menu></app-dashboard-menu>
 
<div class="card">
<div class="PerformanceTrendModalBody">


        <div class="selectPeriodPan selectPeriodModal col-sm-12 col-xs-12 col-md-3 col-lg-3">
            <app-report-filter (outputData)="addItem($event)" [reportName]="'servicePerformance'"></app-report-filter>  
        </div> 
        <div #chartContainer class="dashboardContentAreaRight" style="grid-template-columns:100%; overflow-y: auto; height: 575px;"></div>

  </div> 
</div>

</div>